import React from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import cs from 'classnames';

type TSpecialPriceBadgeProps = {
    className?: string;
};

export const SpecialPriceBadge = ({className}: TSpecialPriceBadgeProps) => {
    return (
        <div className={cs(style.label, className)}>
            <Typography variant={'label-12-r'}>Спеццена</Typography>
        </div>
    );
};
